import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { OnboardingContainerComponent } from '@zero/onboarding/feature-onboarding/web';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  standalone: true,
  imports: [OnboardingContainerComponent, TranslocoPipe, ButtonComponent, RouterLink],
  templateUrl: './investment-strategy-success.component.html',
})
export class InvestmentStrategySuccessComponent {
  public readonly home = commonRoutes.postlogin.member_home;
}

export default InvestmentStrategySuccessComponent;
